module.exports = __webpack_public_path__ + "static/media/Features-img.54ba08b4.png";